import { Clock, Info } from "lucide-react";
import { SectionHeading } from "./Section";
import { Reveal } from "./Reveal";
import { HOURS } from "../data/site";

const todayIdx = (new Date().getDay() + 6) % 7; // Mon=0 ... Sun=6

export const HoursSection = () => (
  <section className="py-24 md:py-32 bg-white" data-testid="hours-section">
    <div className="mx-auto max-w-5xl px-5 sm:px-8">
      <SectionHeading center overline="Opening Hours" title="When We're Open" subtitle="Visit us six days a week, with morning and evening sessions to fit your schedule." />

      <Reveal delay={0.1}>
        <div className="mt-12 overflow-hidden rounded-3xl border border-dash-line bg-dash-bg shadow-[0_20px_40px_rgb(10,37,64,0.05)]">
          {HOURS.map((h, i) => {
            const isToday = i === todayIdx;
            return (
              <div
                key={h.day}
                data-testid={`hours-row-${h.day.toLowerCase()}`}
                className={`flex items-center justify-between gap-4 px-6 md:px-10 py-5 ${i !== HOURS.length - 1 ? "border-b border-dash-line" : ""} ${isToday ? "bg-dash-teal/8" : ""}`}
              >
                <div className="flex items-center gap-3">
                  <Clock className={`h-4 w-4 ${isToday ? "text-dash-teal" : "text-dash-muted/50"}`} />
                  <span className={`font-medium ${isToday ? "text-dash-teal" : "text-dash-ink"}`}>{h.day}</span>
                  {isToday && <span className="rounded-full bg-dash-teal px-2.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-white">Today</span>}
                </div>
                <div className="text-right text-sm md:text-base text-dash-muted font-accent">
                  {h.slots.map((s, si) => (
                    <div key={si}>{s}</div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </Reveal>

      <Reveal delay={0.15}>
        <p className="mt-6 flex items-center justify-center gap-2 text-sm text-dash-muted">
          <Info className="h-4 w-4 text-dash-gold" />
          Hours may vary on holidays. Please call ahead to confirm.
        </p>
      </Reveal>
    </div>
  </section>
);
